<template>
    <div class="stage-intro-card" :style="{color}">
        <div class="icon text-center">
            <slot name="icon"/>
        </div>
        <h3 class="title text-center">
            <slot name="title"/>
        </h3>

        <div class="line"><div class="fill" :style="{background: color}"></div></div>

        <div class="content text-left">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: "StageIntroCard",
    props: {
        color: {
            type: String,
            default: '#000',
        },
    }
}
</script>

<style lang="scss" scoped>
.stage-intro-card{
    padding: 1.4rem;
    border: rgba(black, 0.1) solid 1px;
    border-radius: .3rem;
    box-shadow: rgba(black, 0.1) 0 2px 5px;

    &:hover{
        .line{
            .fill{
                width: 100%;
            }
        }

        .content{
            height: auto;
        }
    }
}
.icon{
    font-size: 3.5rem;
    @media (max-width: 991px) {
        font-size: 2.5rem;
    }
}

.title {
    @media (max-width: 991px) {
        font-size: 1rem;
    }
}

.line{
    margin: 1rem 0;
    height: 3px;
    background: darken(white, 10%);
    position: relative;
    border-radius: 1rem;

    .fill{
        position: absolute;
        top:0;
        left: 0;
        bottom: 0;
        width: 0;
        background: black;
        transition: width .3s;
        border-radius: 1rem;
    }
}


.content{
    height: 0;
    transition: height .3s;
    overflow: hidden;
}
</style>
